 ﻿define('SageDotCom/PatternAnimations/pattern',[
     "SageDotCom/PatternAnimations/gradient",
      "SageDotCom/Utility/viewport",
      "SageDotCom/PatternAnimations/verticalCarousel",
      "ScrollMagic"
 ],
      function (
          animateGradient,
          activateViewport,
          vCarousel,
          ScrollMagic
      ) {
          function patternAnimations() { }

          patternAnimations.prototype.initialize = function () {
              var ctrl = new ScrollMagic.Controller(),
                  animatedGradientsContainers = document.querySelectorAll('.sage-pattern-animation__gradient .animated-gradient'),
                  viewports = document.querySelectorAll('.sage-pattern-animation__viewport'),
                  sections = document.querySelectorAll('.vertical-carousel__slide'),
                  background = document.querySelector('.vertical-carousel__background');

              animateGradient.init(animatedGradientsContainers, ctrl);
              activateViewport.init(viewports, ctrl);
              vCarousel.init(ctrl);
          }

          return new patternAnimations();
      });

